import styled from "styled-components"
import {Row} from "react-bootstrap"

import TabsBase from "@irati/ui/src/Tabs"
import {Input as InputBase} from "@irati/ui/src/FormItem"
import {H4 as H4Base} from "@irati/ui/src//Typography/Heading"

interface MarginProps {
  margin?: string
}

export const FlexRowSpaceBetween = styled.div<MarginProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({margin}) => margin && `margin: ${margin};`}
`

export const FlexRowSpaceBetween50Buttons = styled(FlexRowSpaceBetween)`
  button {
    width: 50%;
    &:first-child {
      margin-right: 15px;
    }
  }
`

export const ListItemWithActions = styled(FlexRowSpaceBetween)`
  img {
    width: 50px;
    height: 50px;
    border-radius: 3px;
    margin-right: 15px;
  }
`

export const Tabs = styled(TabsBase)`
  margin-top: 15px;
`

export const Input = styled(InputBase)<MarginProps>`
  ${({margin}) => margin && `margin: ${margin};`}
`

export const H4 = styled(H4Base)`
  margin: 50px 0 100px;
`

export const Slider = styled.div`
  overflow: auto;
  white-space: nowrap;
`

export const OccasionIcon = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 3px;
  margin-right: 15px;
  opacity: .2;
  transition: opacity .2s;
  cursor: pointer;
  &.selected {
    opacity: 1;
  }
`

export const PickerWrapper = styled(Row)`
  margin-top: 30px;
  margin-bottom: 30px;
`
